import React, { Component } from 'react';
//import logo from './logo.svg';
import './App.css';
import {Grid, Label, Segment, Form, TextArea, Dropdown, Loader} from 'semantic-ui-react';
//const languageOptions = [ { key: 'Indonesian', text: 'Indonesian', value: 'id' }, { key: 'English', text: 'English', value: 'en' } ];
const languageOptions = [ { key: 'Indonesian', text: 'Indonesian', value: 'id' } ];
const exampleOptions = { id:'e.g. "Saya cinta Bahasa Indonesia.\"',
    en: 'e.g. \"I love English\"'};

const tagColors = [
    {tag:'NOUN', color:'#20BB9B', text:'Noun'},
    {tag:'PROPN', color:'#32CB70', text:'Proper Noun'},
    {tag:'PRON', color:'#3797DA', text:'Pronoun'},
    {tag:'VERB', color:'#9A59B5', text:'Verb'},
    {tag:'ADV', color:'#6E81B6', text:'Adverb'},
    {tag:'ADJ', color:'#E57D27', text:'Adjective'},
    {tag:'ADP', color:'#E64D3E', text:'Adposition'},
    {tag:'DET', color:'#F491A4', text:'Determiner'},
    {tag:'NUM', color:'#F1C317', text:'Numeral'},
    {tag:'AUX', color:'#EA9284', text:'Auxiliary'},
    {tag:'PART', color:'#97BFBB', text:'Particle'},
    {tag:'INTJ', color:'#3FA2AA', text:'Interjection'},
    {tag:'CCONJ', color:'#22A061', text:'Conjunction Coordinative'},
    {tag:'SCONJ', color:'#B13190', text:'Conjunction Subordinative'},
    {tag:'PUNCT', color:'#CCCCCC', text:'Punctuation'},
    {tag:'SYM', color:'#22374F', text:'Symbol'},
    {tag:'X', color:'#495D6F', text:'Other'},
];

//const maxTextLength = 1000
const maxTextLength = 250

class MorphologyTools extends Component {
    createLegend() {
         const listItems = tagColors.map((token, index) =>
            <Segment textAlign='center' inverted key={token.tag} style={{ padding: '0.5em 0em', backgroundColor: token.color }}><span  className="small text">{token.text}</span></Segment>
           );
         this.setState({
             legend: listItems
         });
    }

    componentWillMount() {
        var x = tagColors.map(obj =>{
            var rObj = {};
            var tag = obj.tag
            rObj[tag] = obj.color;
            return rObj;
            });

            var dict = {};
            for(let i=0;i<x.length;i++) {
                for(let key in x[i]) {
                    dict[key] = x[i][key];
                }
            }
            this.setState({
                colorcode: dict
            });

    }

    componentDidMount() {
        this.createLegend();
      }

    constructor(props) {
        super(props);
        this.state = {
            value: 'Put your text here.',
            example: exampleOptions['id'],
            languageID:"id",
            result: 'none',
            buttonSubmitDisabled:<Form.Button color='green' type="submit" disabled>Analyze</Form.Button>,
            resultTokens:<div/>,
            resultStateHidden:1,
            legend:<div/>,
            colorcode: [],
            textLength:0
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleChangeLanguage = this.handleChangeLanguage.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleResult = this.handleResult.bind(this);

    }
    render() {
        return (
            <div>
            <Grid>
                <Grid.Column width={13}>
                <Segment attached='top'>
                    <div  style={{ margin: '0em 0em 0.5em 0em' }} >This text below is in <Dropdown downward='true' floating inline options={languageOptions} defaultValue='id' onChange={this.handleChangeLanguage} />: </div>

                    <Form onSubmit={this.handleSubmit}>
                        <Form.Field>
                             <Segment padded>
                             <Label attached='bottom right'>{this.state.textLength}/{maxTextLength}</Label>
                            <TextArea placeholder={this.state.value + " " + this.state.example} onChange={this.handleChange} style={{ margin: '0em 0em',  minHeight: 120, border:'none', resize: 'none' }} maxLength={maxTextLength} />

                             </Segment>
                            {this.state.buttonSubmitDisabled}
                        </Form.Field>
                    </Form>
                </Segment>
                <ResultArea result={this.state.resultTokens} hidden={this.state.resultStateHidden}/>
                {/*<Segment attached>
                    <Form>
                        <Form.Field>
                            <TextArea onChange={this.handleResult} style={{ margin: '1em 0em' }} value={this.state.result}/>
                        </Form.Field>
                    </Form>
                </Segment>*/}
                </Grid.Column>
                <Grid.Column width={3}>

                <div>
                <Segment.Group>
                    {this.state.legend}
                    </Segment.Group>
                </div>
                </Grid.Column>
                </Grid>
            </div>

        );
    }




    handleChange(event) {
        var flag = <Form.Button color='green' type="submit" disabled>Analyze</Form.Button>;
        if (event.target.value.length > 0) {
            flag = <Form.Button color='green' type="submit">Analyze</Form.Button>
        }
        this.setState({
            value: event.target.value,
            textLength:event.target.value.length,
            buttonSubmitDisabled:flag
        });
    }
    handleResult(event) {
    }

    handleChangeLanguage(e, data) {
        this.setState(
            {
                languageID: data.value,
                example: exampleOptions[data.value]
            });
        //alert('The new text: ' + data.value);
    }

    handleSubmit(event) {



        //alert('The new text: ' + this.state.value);
        var searchTerm = this.state.value;
        var langid = this.state.languageID;
        //alert('The new text: ' + this.state.languageID);
        //searchTerm = searchTerm.trim();
        //searchTerm = searchTerm + ' ' + searchTerm.toLowerCase();
        //searchTerm = searchTerm.split(/\s+/);
        //const uniqueValues = [...new Set(searchTerm)];
        //searchTerm = uniqueValues.join(' ');

        const datatest = {
            query: ""+searchTerm,
            languageID: ""+langid,
            resultStateHidden:2
        };
        //console.log(JSON.stringify(datatest));

        //fetch('https://q7jcjzvihc.execute-api.us-east-1.amazonaws.com/prod?query=adik,baju,mencuci,serang')
        //fetch('https://q7jcjzvihc.execute-api.us-east-1.amazonaws.com/prod?query=' + this.state.value)
        //fetch('https://q7jcjzvihc.execute-api.us-east-1.amazonaws.com/prod?query=' + searchTerm)
        fetch('https://q7jcjzvihc.execute-api.us-east-1.amazonaws.com/prod', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(datatest)
        })
        .then(response => response.json())
        .then((data) => {
              console.log(data);
              //console.log(data.Items);
              var unknown = "";
              const tokens = [];
              for (let i = 0; i < data.length; i++) {
                  if (data[i].pos === undefined) {
                      unknown += data[i].text + "\t" + data[i].text + "\t\n"
                  }
                  tokens.push({
                      text: data[i].text,
                      pos: data[i].pos,
                      color: this.state.colorcode[data[i].pos],
                      fakekey:data[i].fakekey
                  });
              }

                const listItems = tokens.map((token, index) =>
                  <Label size='small' key={token.fakekey} style={{ margin: '0.3em 0.3em', backgroundColor: token.color, color:'#FFFFFF' }}>{token.text}<Label.Detail>{token.pos}</Label.Detail></Label>
                  );

              this.setState({
                  resultTokens: listItems,
                  result: unknown,
                  resultStateHidden:0
              });
          })
          .catch((error) => {
              console.error(error);
          });

        event.preventDefault();
    }








}

function ResultArea(props) {
    if (props.hidden == 1) {
        return  <Segment attached hidden><div>{props.result}</div></Segment>;
    }
    else if (props.hidden == 2) {
        return  <Segment attached hidden><div><Loader active /></div></Segment>;
    }
  return  <Segment attached><div>{props.result}</div></Segment>;
}


export default MorphologyTools;



// WEBPACK FOOTER //
// ./src/MorphologyTools.js